/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import store from '@/store';

const getLabel = require('@/utils/labels.js').default;
const dashboardConfiguration = require('@/configs/contentTypeBoardConfig.json');
const talentConfig = require('./talent.json');

const { VUE_APP_ENVIROMENT } = process.env;

const findLabel = label => {
  if (!label) {
    return null;
  }
  return getLabel(label);
};

const getDashboardConfiguration = () => dashboardConfiguration;

const getConfiguratonFile = file => {
  let fileData = null;
  try {
    fileData = require(`./${file}`);
  } catch (error) {
    console.error(error);
  }

  return fileData;
};

const getFacetsConfiguration = view => {
  const config = talentConfig[VUE_APP_ENVIROMENT];

  const allowedConfig = {};
  //  GET CONFIG FILE
  if (config[view].facetConfigFile) {
    const facetConfigFile = require(`./${config[view].facetConfigFile}`);

    Object.entries(facetConfigFile).forEach(([key, property]) => {
      if (store.state.user?.roles && property.roles) {
        const isAllowed = store.getters.allowAction(property.roles);

        if (!isAllowed) return;
      }
      if (property.hideFieldWhen) {
        const isAllowed = store.getters.allowField(property.hideFieldWhen);

        if (!isAllowed) return;
      }

      allowedConfig[key] = property;
    });
  }

  return allowedConfig;
};

const getTargetingConfig = context => {
  const facetConfigFile = require(`./${context}TargetingFacets.json`);
  return facetConfigFile;
};

const getDataTableHeadersConfiguration = view => {
  const config = talentConfig[VUE_APP_ENVIROMENT];

  //  GET CONFIG FILE
  const allowedConfig = [];
  if (config[view].tableConfig) {
    const configHeader = require(`./${config[view].tableConfig}`);

    configHeader.forEach(property => {
      if (property.roles) {
        const isAllowed = store.getters.allowAction(property.roles);

        if (!isAllowed) return;
      }
      if (property.hideFieldWhen) {
        const isAllowed = store.getters.allowField(property.hideFieldWhen);

        if (!isAllowed) return;
      }

      if (property.label) {
        property.text = findLabel(property.label);
      }

      allowedConfig.push(property);
    });
  }

  return allowedConfig;
};

const getNestedProperty = (obj, path, defaultValue = null) => path.split('.').reduce((acc, part) => (
  acc ? acc[part] : undefined
), obj) || defaultValue;

const isPublicationDateValid = (startTimestamp, endTimestamp) => {
  const currentDate = Math.floor(Date.now() / 1000);
  return startTimestamp <= currentDate && endTimestamp >= currentDate;
};

const isToday = timestamp => {
  const today = new Date();
  const date = new Date(timestamp * 1000);

  return date.getDate() === today.getDate()
    && date.getMonth() === today.getMonth()
    && date.getFullYear() === today.getFullYear();
};

const normalize = str => (str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() : '');

const filterListBySearch = (list, searchTerm) => {
  if (!searchTerm) return list;
  const term = normalize(searchTerm);
  return list.filter(e => normalize(e.name).includes(term) || normalize(e.uuid).includes(term));
};

const generateUniqueId = () => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 15);
  const uniqueId = `${timestamp}_${random}`;
  return uniqueId;
};

export {
  getFacetsConfiguration,
  getDataTableHeadersConfiguration,
  getTargetingConfig,
  getDashboardConfiguration,
  getConfiguratonFile,
  getNestedProperty,
  isPublicationDateValid,
  isToday,
  filterListBySearch,
  generateUniqueId
};
